import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { action, observable } from 'mobx';
import queryString from 'query-string';
import { Subject } from 'rxjs';
import { EnumAPI } from '../../apis';
import { BasesPagination } from '../../controller';
import { EnumMicroApp, EnumOutagePosition } from '../../enums';
import { getDepth, Log, toArrayTreeMaping } from '../../helpers';
import { ISystemApply, ISystemMenu } from '../../interface';
import { OutagesNoticeController } from './outagesNotice';
@BindAll()
export class ApplyController {
  @observable
  loading = true;
  /**
   * 菜单树
   * @type {Array<Imenu>}
   * @memberof ApplyController
   */
  @observable
  MenuTree: Array<ISystemMenu> = [];
  /**
   * 菜单 平铺
   * @type {Array<Imenu>}
   * @memberof ApplyController
   */
  Menuflat: Array<Omit<ISystemMenu, 'children'>> = [];
  /**
   * 存储已加载的 key
   * @memberof ApplyController
   */
  LazyKey = new Map();
  /**
   * 公告
   * @memberof ApplyController
   */
  outagesNoticeController = new OutagesNoticeController();
  /**
   * 菜单异步数据加载订阅
   * @type {Promise<any>}
   * @memberof ControllerUser
   */
  readonly MenuSubject = new Subject();
  /**
   * 菜单列表
   * @memberof ApplyController
   */
  Menu = new BasesPagination<ISystemMenu>({
    // listModel: { storageKey: 'menu' },
    pagination: EnumAPI.idass_get_menu_lazy,
    // pagination: EnumAPI.idass_get_menu_list,
    infinite: true,
    paginationParams: {
      defaultCurrent: null,
      defaultPageSize: null,
      response: {
        // dataSource: 'menus',
        valueGetter: async (res) => {
          const outages = await this.outagesNoticeController.getUserOutageMenu(
            EnumOutagePosition.PC_PORTAL_TOP,
          );
          const dataSource = lodash.map(lodash.get(res, 'menus'), (menu) => {
            menu.outagesStatus = lodash.includes(outages, menu.id) ? 0 : 1;
            return this.toMenuItem(menu);
          });
          return {
            dataSource,
          };
        },
      },
    },
  });
  /**
   * APP 应用列表
   * @memberof ApplyController
   */
  App = new BasesPagination<ISystemApply>({
    paginationParams: {
      defaultCurrent: null,
      defaultPageSize: null,
    },
  });
  /**
   * 初始化菜单
   * @param parentId
   * @param depth
   */
  async onAppInit() {
    if (!this.loading) {
      return console.warn('已初始化完成');
    }
    await this.Menu.onLoad();
    this.toParsingApp();
    this.toMenuTree();
    this.MenuSubject.complete();
  }
  @action
  private toMenuTree() {
    const tree = toArrayTreeMaping(this.Menu.dataSource, {
      dataKey: 'id',
      childrenKey: 'children',
      // parentValue: [355],
      // valueGetter: this.toMenuItem,
    });
    Log.success('【 菜单树 】', tree);
    this.MenuTree = tree;
    this.loading = false;
  }
  /**
   * 解析 APP
   * @private
   * @memberof ApplyController
   */
  private toParsingApp() {
    const app = lodash.map(
      lodash.intersectionBy(this.Menu.dataSource, 'appId'),
      (menu) => {
        return lodash.pick(menu, [
          'appId',
          'baseRoute',
          'rootDomain',
          'routeType',
        ]);
      },
    );
    this.App.set({ dataSource: app });
  }

  /**
   * 加载子集
   * @param {number} [parentId=0]
   * @param {number} [depth=0] 加载几层
   * @return {*}
   * @memberof ApplyController
   */
  async onLazyChildren(parentId = 0, depth = 0) {
    try {
      if (this.LazyKey.has(parentId)) {
        return console.warn('已加载');
      }
      this.LazyKey.set(parentId, parentId);
      await this.Menu.onLoad({ body: { parentId, depth, allLevel: 1 } });
      this.toMenuTree();
    } catch (error) {
      console.error(error);
      this.LazyKey.delete(parentId);
    }
  }
  /**
   * 获取菜单层级
   * @param {ISystemMenu} menu
   * @return {*}
   * @memberof ApplyController
   */
  getDepth(menu: ISystemMenu) {
    return getDepth(menu, 1);
  }
  /**
   * 拼接Url
   * @param data
   * @returns
   */
  protected pathJoin(data: Array<string>) {
    data = lodash.compact(
      lodash.map(data, (x) => lodash.trim(lodash.trim(x, '/'))),
    );
    return lodash.join(['', ...data], '/');
  }
  /**
   * 转换 path url
   * @param {ISystemMenu} item
   * @return {*}
   * @memberof ApplyController
   */
  protected toPath(item: ISystemMenu) {
    // 无连接配置信息
    if (!lodash.size(lodash.compact([item.origin, item.pathname, item.hash]))) {
      return;
    }
    let path = ``;
    if (item.extJump) {
      path = lodash.trimStart(
        this.pathJoin([item.origin, item.pathname, item.hash]),
        '/',
      );
    } else if (item.origin) {
      // iframe
      path = this.pathJoin([
        EnumMicroApp.IframePage,
        item.code,
        // item.pathname,
        // item.hash,
      ]);
    } else {
      let paths = [
        EnumMicroApp.MicroPage,
        item.baseRoute,
        item.pathname,
        item.hash,
      ];
      if (lodash.includes(['', '/', 'product', 'oldsmb'], item.baseRoute)) {
        paths = lodash.tail(paths);
      }
      // 微前端
      path = this.pathJoin(paths);
    }
    return path || `/${item.id}`;
  }
  /**
   * 转换菜单数据
   * @param item
   * @returns
   */
  protected toMenuItem(item: ISystemMenu) {
    const path = this.toPath(item);
    return lodash.assign(item, {
      key: String(item.id),
      path,
    });
  }
  /**
   * 根据 key 获取菜单
   * @param {string} key
   * @return {*}
   * @memberof ApplyController
   */
  getMenu(key: string) {
    return lodash.find(this.Menu.dataSource, ['key', key]);
  }
  /**
   * 获取菜单的 key 组合 路径
   * @param location
   * @returns
   */
  getPathKey(location: Partial<Location>) {
    return this.pathJoin([location.pathname, location.hash]);
  }
  onReset() {
    this.Menu.reset();
    this.App.reset();
    // await lastValueFrom(of(1).pipe(delay(BasesOptions.debounce * 1.5)));
  }
  /**
   *  path 参数获取菜单 携带?xx= 参数和去除?xxx= 参数同时查找
   * @param {*} path
   * @return {*}
   * @memberof ApplyController
   */
  getPathtoMenu(path) {
    const { url } = queryString.parseUrl(path);
    return lodash.find(this.Menu.dataSource, (item) =>
      lodash.includes([url, path], item.path),
    );
  }
  /**
   * 查询APP
   * @param baseRoute
   * @returns
   */
  getApp(baseRoute: string) {
    return lodash.cloneDeep(
      lodash.find(this.App.dataSource, ['baseRoute', baseRoute]),
    );
  }
  /**
   * code 查询 外部链接
   * @param code
   * @returns
   */
  getWebview(code) {
    const menu = lodash.find(this.Menu.dataSource, ['code', code]);
    if (menu) {
      return lodash.trimStart(
        this.pathJoin([menu.origin, menu.pathname, menu.hash]),
        '/',
      );
    }
  }
}
